import './email-attachments-group.scss';

import EmailAttachmentsGroup from './EmailAttachmentsGroup';

export default EmailAttachmentsGroup;
